import { Col, Row } from 'react-bootstrap'
import styled from 'styled-components'

export const Rowcomponent = styled(Row)`` 

export const Colcomponent = styled(Col)`
    width: 60vw; 
    height: 70vh;
`